export const Frequency = {
    UPON_REQUEST: 'UponRequest',
    EVERY_WEEK: 'EveryWeek',
    EVERY_TWO_WEEKS: 'EveryTwoWeeks',
    EVERY_FOUR_WEEKS: 'EveryFourWeeks',
    EVERY_SIX_WEEKS: 'EverySixWeeks',
    EVERY_EIGHT_WEEKS: 'EveryEightWeeks',
    EVERY_TWELVE_WEEKS: 'EveryTwelveWeeks',
    EVERY_SEMESTER: 'EverySemester',
    EVERY_YEAR: 'EveryYear',
} as const;

export type FrequencyValue = (typeof Frequency)[keyof typeof Frequency];
export type FrequencyKey = keyof typeof Frequency;
